import React from 'react';
import { Tag } from 'antd';

const TierBadge = ({ tier }) => {
  const tierConfig = {
    standard: {
      color: 'default',
      label: 'Standard',
      style: { backgroundColor: 'var(--rlc-neutral-500)', color: 'white', border: 'none' }
    },
    business: {
      color: 'blue',
      label: 'Business',
      style: { backgroundColor: 'var(--rlc-state-info)', color: 'white', border: 'none' }
    },
    enterprise: {
      color: 'purple',
      label: 'Enterprise',
      style: { backgroundColor: 'var(--rlc-surface-inverse)', color: 'white', border: 'none' }
    },
    aws_organization: {
      color: 'gold',
      label: 'AWS Org',
      style: { backgroundColor: 'var(--rlc-state-warning)', color: 'white', border: 'none' }
    }
  };

  const config = tierConfig[tier] || tierConfig.standard;

  return (
    <Tag style={config.style}>
      {config.label}
    </Tag>
  );
};

export default TierBadge;
